<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ caption }}: {{ currentMenu }}</span>
    </p>
    <div style="position: relative;">
      <TableWrapper
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :border="false"
        :offset-height="offsetHeight"
        @on-add="showFormModalDialog"
      />
      <MenuFunctionForm
        :id="entityId"
        :menu-id="menuId"
        :visible="modalForm"
        :width="450"
        :action="formAction"
        @on-close="onModalClose"
      />
    </div>
  </Modal>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import MenuFunctionForm from './menu-functionForm'
import request from '@/utils/request'
export default {
  name: 'MenuFunctionDialog',
  components: {
    TableWrapper,
    MenuFunctionForm
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    },
    currentMenu: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      url: '',
      modalForm: false,
      entityId: 0,
      modalDelConfirm: false,
      entityName: '',
      modCount: 0,
      menuId: 0,
      selection: []
    }
  },
  computed: {
    formAction() {
      return this.action + '/' + this.id + '/function'
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    offsetHeight() {
      return 480
    },
    columns() {
      return [
        { title: '功能名称', align: 'center', key: 'label', sortable: true },
        { title: '权限标识', align: 'left', key: 'name', sortable: true, width: 220 },
        { title: '功能路径', align: 'center', key: 'path', sortable: true },
        { title: '功能描述', align: 'center', key: 'description', sortable: true },
        { title: '功能方法', align: 'center', key: 'method', sortable: true, width: 120 },
        { title: '操作', align: 'center', width: 140,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showDelModalDialog(params.row.id, params.row.label)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ])
            ])
          }
        }]
    }
  },
  watch: {
    showModal(val) {
      if (val && this.id) {
        this.url = this.action + '/' + this.id + '/function'
        this.menuId = this.id
      }
    }
  },
  methods: {
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    showDelModalDialog: function(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除菜单功能么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '菜单功能 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '菜单功能 `' + name + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.entityName = ''
      this.modalForm = false
      this.modalDelConfirm = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    closeModal: function(changed = false) {
      this.url = ''
      this.menuId = 0
      this.$emit('on-close', changed)
    }
  }
}
</script>
